var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChalet = function SvgChalet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.485 13H19v9H5v-9H3.605a1.605 1.605 0 0 1-1.051-2.817l8.126-7.04a2 2 0 0 1 2.63.01L17 6.4V3h2v5.16l2.486 2.188A1.515 1.515 0 0 1 20.485 13ZM17 13v1H7v-1h10ZM7 17v-1h2v1H7Zm6 0v-1h4v1h-4Zm0 2h4v1h-4v-1Zm-4 0v1H7v-1h2Zm-4-8h-.335l1.154-1h12.245l1.136 1H5Zm10.79-3H8.129l1.155-1h5.371l1.137 1Zm-3.408-3h-.79l.398-.345.392.345Z",
    clipRule: "evenodd"
  })));
};
export default SvgChalet;